import { useState, useCallback } from 'react';
import { ParsedMarkdown } from './types';
import { parseMarkdown } from './parsers/markdownParser';
import { detectConflicts } from './analyzers/conflictDetector';
import FileUpload from './components/FileUpload';
import MindMap from './components/MindMap';

function App() {
  const [parsedData, setParsedData] = useState<ParsedMarkdown | null>(null);
  const [fileName, setFileName] = useState<string>('');

  const handleFileLoaded = useCallback((content: string, name: string) => {
    try {
      // Parse markdown
      const qaPairs = parseMarkdown(content);

      // Detect conflicts
      const conflicts = detectConflicts(qaPairs);

      // Create parsed data structure
      const parsed: ParsedMarkdown = {
        qaPairs,
        conflicts,
        metadata: {
          fileName: name,
          parseDate: new Date(),
        },
      };

      setParsedData(parsed);
      setFileName(name);
    } catch (error) {
      console.error('Failed to parse markdown:', error);
      alert('Failed to parse markdown file. Please check the format and try again.');
    }
  }, []);

  const handleReset = useCallback(() => {
    setParsedData(null);
    setFileName('');
  }, []);

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      {!parsedData ? (
        <FileUpload onFileLoaded={handleFileLoaded} />
      ) : (
        <>
          <MindMap parsedData={parsedData} fileName={fileName} />

          {/* Reset Button */}
          <button
            onClick={handleReset}
            style={{
              position: 'absolute',
              top: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              padding: '10px 20px',
              background: '#64748b',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '14px',
              cursor: 'pointer',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              zIndex: 10,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#475569';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#64748b';
            }}
          >
            ← Upload New File
          </button>
        </>
      )}
    </div>
  );
}

export default App;
